<div class="my-bets-settled-filter-modal" [ngClass]="{ 'my-bets-settled-filter-modal--dirty': isStateModelDirty }">
    <a class="my-bets-settled-filter-modal__reset-button" (click)="handleResetButtonClick()">{{ translations.reset_button_title }}</a>
    <fieldset class="state-filter">
        <div>{{ translations.bet_result_title }}</div>
        <div class="my-bets-settled-filter-modal_buttons">
            <div>
                <button class="ms-modal-toggle-button" [ngClass]="{ selected: !stateModel }" (click)="setState('')">
                    {{ translations.all }}
                </button>
            </div>
            <div>
                <button class="ms-modal-toggle-button" [ngClass]="{ selected: stateModel === 'Won' }" (click)="setState('Won')">
                    {{ translations.won }}
                </button>
            </div>
            <div>
                <button class="ms-modal-toggle-button" [ngClass]="{ selected: stateModel === 'Lost' }" (click)="setState('Lost')">
                    {{ translations.lost }}
                </button>
            </div>
            <div>
                <button class="ms-modal-toggle-button" [ngClass]="{ selected: stateModel === 'Other' }" (click)="setState('Other')">
                    {{ translations.cancelled }}
                </button>
            </div>
        </div>
    </fieldset>

    <fieldset class="dates-filter">
        <div>{{ translations.time_range_title }}</div>
        <div class="my-bets-settled-filter-modal_dates">
            <div>
                <input type="date" [min]="rangeConstraints.minFromDate" [max]="rangeConstraints.maxFromDate" [(ngModel)]="fromDate" />
                <span>{{ translations.start_date_placeholder }}</span>
            </div>
            <div>
                <input type="date" [min]="rangeConstraints.minToDate" [max]="rangeConstraints.maxToDate" [(ngModel)]="toDate" />
                <span>{{ translations.end_date_placeholder }}</span>
            </div>
        </div>

        @if (showIntervalAutoChangedInfo) {
            <div class="my-bets-settled-filter-modal_dates--info" *msShowInEpcot="false">
                <vn-icon class="filter-icon" name="theme-info-i" size="16" />
                <span
                    >{{ translations.interval_adapted_message }} <a class="help-and-contact" [href]="helpAndContact">{{ translations.contact_us }}</a>
                </span>
            </div>
            <ng-container *msShowInEpcot="true">
                <ms-epcot-notification [message]="translations.interval_adapted_message" [notificationType]="'info'" />
            </ng-container>
        }
    </fieldset>
    <div class="my-bets-settled-filter-modal_button-results">
        <button ds-button kind="primary" variant="filled" size="large" truncate="true" (click)="onFilter()">
            {{ translations.results_button_title }}
        </button>
    </div>
</div>
